import { dropdownOpen } from '../overlays/dropdownOpen'
import { get } from 'svelte/store'

export function clickOutside(element: any) {
	function handleClick(event: MouseEvent) {
		if (
			!(event.target as HTMLAnchorElement).download &&
			!(event.target as Element).closest('[data-prevent-click-outside]') &&
			element &&
			!element.contains(event.target) &&
			!event.defaultPrevented
		) {
			element.dispatchEvent(new CustomEvent('clickOutside', element))
		}
	}

	document.addEventListener('click', handleClick, true)

	return {
		destroy() {
			document.removeEventListener('click', handleClick, true)
		},
	}
}

export function clickOutsidePortal(element: any) {
	function handleClick(event: MouseEvent) {
		if (element && !element.contains(event.target) && !event.defaultPrevented) {
			element.dispatchEvent(new CustomEvent('clickOutsidePortal', element))
		}
	}

	document.addEventListener('click', handleClick, true)

	return {
		destroy() {
			document.removeEventListener('click', handleClick, true)
		},
	}
}

export function closeOnEscape(element: any, param = { dropdown: false }) {
	function handleEscape(event: KeyboardEvent) {
		if (
			!event.defaultPrevented &&
			event.key === 'Escape' &&
			(!get(dropdownOpen) || param.dropdown)
		) {
			element.dispatchEvent(new CustomEvent('closeOnEscape'))
		}
	}

	document.addEventListener('keydown', handleEscape, true)

	return {
		destroy() {
			document.removeEventListener('keydown', handleEscape, true)
		},
	}
}
